<template>
  <div id="tags-view-container" class="tags-view-container">
    <el-row>
      <el-col :span="2" style="min-width:120px">
        <div v-if="permission_module.length > 1" class="tags-view-left-menu">
          <el-popover
            v-model="visibleMenu"
            :placement="$global.isPC?'bottom-start':'bottom-end'"
            :width="$global.isPC?'500':'350'"
            trigger="click"
            popper-class="tags-view-left-menu-popover"
          >
            <div>
              <div v-for="(item,key) in visitedViews" :key="key">
                <div v-if="key!==permission_routesType" style="border-bottom:1px solid #eee;overflow:auto;zoom:1">
                  <span class="tags-view-left-menu-title" @click="changeMenu(key)">| {{ findModules(key) }} | </span>
                  <span>
                    <a
                      v-for="tag in item"
                      ref="tags"
                      :key="tag.path"
                      :class="isActive(tag)?'active':''"
                      class="tags-view-item"
                      @click.stop="changeRouter({ path: tag.path, query: tag.query, fullPath: tag.fullPath })"
                    >
                      <span class="tags-view-left-menu-router" @click="visibleMenu = !visibleMenu">
                        {{ tag.title }}
                        <span v-if="!tag.meta.affix" class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag,key)" />
                      </span>
                    </a>
                  </span>
                  <span v-if="item.length === 0" class="module-into">
                    <el-button size="mini" type="primary" plain @click="changeMenu(key)">进入</el-button>
                  </span>
                </div>
              </div>
            </div>
            <div slot="reference" class="tags-view-left-menu-reference">
              <i class="el-icon-sort" style="transform: rotate(-90deg)" />
              切换页面 <span>{{ getVisitedViewsLength() }}</span>
            </div>
          </el-popover>
        </div>
      </el-col>
      <el-col :span="21" style="max-width:calc(100vw - 130px)">
        <transition name="left">
          <div v-show="menuShow" class="tags-view-wrapper" :style="permission_module.length === 1?'margin-left:15px':''">
            <scroll-pane v-if="scrollPaneShow" ref="scrollPane">
              <template>
                <div
                  v-for="tag in visitedViews[permission_routesType]"
                  :key="tag.path"
                  class="tags-view-item"
                  :class="isActive(tag)?'active':''"
                >
                  <router-link
                    ref="tag"
                    :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }"
                    tag="span"
                    @click.middle.native="closeSelectedTag(tag,permission_routesType)"
                    @contextmenu.prevent.native="openMenu(tag,$event)"
                    @click.native.stop="visibleMenu = false"
                  >
                    {{ tag.title }}
                  </router-link>
                  <span v-if="!tag.meta.affix" class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag,permission_routesType)" />
                </div>
              </template>

            </scroll-pane>
          </div>
        </transition>
      </el-col>
    </el-row>

    <ul v-show="visible" :style="{left:left+'px',top:top+'px'}" class="contextmenu">
      <li @click="refreshSelectedTag(selectedTag)">刷新</li>
      <li v-if="!(selectedTag.meta&&selectedTag.meta.affix)" @click="closeSelectedTag(selectedTag)">关闭</li>
      <li @click="closeOthersTags">关闭其他</li>
      <li @click="closeAllTags(selectedTag)">关闭所有</li>
      <li @click="open(selectedTag)">新窗口打开</li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ScrollPane from './ScrollPane'
import path from 'path'
export default {
  components: { ScrollPane },
  data() {
    return {
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {},
      affixTags: [],
      menuShow: true,
      visibleMenu: false,
      scrollPaneShow: true
    }
  },
  computed: {
    ...mapGetters([
      'permission_routesType',
      'permission_module'
    ]),
    visitedViews() {
      const list = {}
      this.permission_module.forEach(data => {
        list[data.toUpperCase()] = []
        this.$store.state.tagsView.visitedViews.forEach(item => {
          if (data.toUpperCase() === item.module || item.module === '*') {
            // 特定模块 或者 *管理员模块则 所有模块都会有
            list[data.toUpperCase()].push(item)
          }
        })
      })

      return list
    },
    routes() {
      return this.$store.state.permission.routes
    }
  },
  watch: {
    permission_routesType(newValue, oldValue) {
      this.menuShow = false
      this.visible = false
      setTimeout(() => {
        this.menuShow = true
      }, 500)
    },
    $route() {
      this.addTags()
      this.moveToCurrentTag()
    },
    visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  mounted() {
    this.initTags()
    this.addTags()
  },
  methods: {
    changeRouter(path) {
      setTimeout(() => {
        this.$router.push(path)
      }, 100)
    },
    findModules(key) {
      let name = ''
      this.$global.modules.some(element => {
        if (element.value === key) {
          name = element.name
          return
        }
      })

      return name
    },
    getVisitedViewsLength() {
      let length = 0
      for (const key in this.visitedViews) {
        if (key !== this.permission_routesType) {
          length += this.visitedViews[key].length
        }
      }
      return length > 0 ? `(${length})` : ''
    },
    isActive(route) {
      return route.path === this.$route.path
    },
    filterAffixTags(routes, basePath = '/') {
      let tags = []
      routes.forEach(route => {
        if (route.meta && route.meta.affix) {
          const tagPath = path.resolve(basePath, route.path)
          tags.push({
            fullPath: tagPath,
            path: tagPath,
            name: route.name,
            meta: { ...route.meta }
          })
        }
        if (route.children) {
          const tempTags = this.filterAffixTags(route.children, route.path)
          if (tempTags.length >= 1) {
            tags = [...tags, ...tempTags]
          }
        }
      })
      return tags
    },
    initTags() {
      const affixTags = this.affixTags = this.filterAffixTags(this.routes)
      for (const tag of affixTags) {
        // Must have tag name
        if (tag.name) {
          this.$store.dispatch('tagsView/addVisitedView', tag)
        }
      }
    },
    addTags() {
      const { name } = this.$route
      if (name) {
        const module = this.$route.path.split('/')[1] === 'admin' ? '*' : this.permission_routesType// 判断是否管理员模块
        this.$store.dispatch('tagsView/addView', { ...this.$route, module: module })
      }
      return false
    },
    moveToCurrentTag() {
      const tags = this.$refs.tag
      this.$nextTick(() => {
        for (const tag of tags) {
          if (tag.to.path === this.$route.path) {
            this.$refs.scrollPane.moveToTarget(tag)
            // when query is different then update
            if (tag.to.fullPath !== this.$route.fullPath) {
              this.$store.dispatch('tagsView/updateVisitedView', this.$route)
            }
            break
          }
        }
      })
    },
    refreshSelectedTag(view) {
      this.$store.dispatch('tagsView/delCachedView', view).then(() => {
        const { fullPath } = view
        this.$nextTick(() => {
          this.$router.replace({
            path: '/redirect' + fullPath
          })
        })
      })
    },
    closeSelectedTag(view, permission_routesType) {
      console.log(view)
      this.$store.dispatch('tagsView/delView', view).then(({ visitedViews }) => {
        if (this.isActive(view)) {
          this.toLastView(visitedViews, view)
        }
      })
    },
    closeOthersTags() {
      this.$router.push(this.selectedTag)
      this.$store.dispatch('tagsView/delOthersViews', this.selectedTag).then(() => {
        this.moveToCurrentTag()
      })
    },
    closeAllTags(view) {
      this.$store.dispatch('tagsView/delAllViews').then(({ visitedViews }) => {
        if (this.affixTags.some(tag => tag.path === view.path)) {
          return
        }
        this.toLastView(visitedViews, view)
      })
    },
    open(view) {
      window.open('/#' + view.fullPath)
    },
    toLastView(visitedViews, view) {
      const latestView = this.visitedViews[this.permission_routesType].slice(-1)[0]
      if (latestView) {
        this.$router.push(latestView)
      } else {
        // now the default is to redirect to the home page if there is no tags-view,
        // you can adjust it according to your needs.
        if (view.name === 'Dashboard') {
          // to reload home page
          this.$router.replace({ path: '/redirect' + view.fullPath })
        } else {
          this.$router.push('/')
        }
      }
    },
    openMenu(tag, e) {
      const menuMinWidth = 105
      const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
      const offsetWidth = this.$el.offsetWidth // container width
      const maxLeft = offsetWidth - menuMinWidth // left boundary
      const left = e.clientX - offsetLeft + 15 // 15: margin right
      if (left > maxLeft) {
        this.left = maxLeft
      } else {
        this.left = left
      }
      this.top = e.clientY
      this.visible = true
      this.selectedTag = tag
    },
    closeMenu() {
      this.visible = false
    },
    changeMenu(command) {
      this.visibleMenu = false
      this.$store.dispatch('permission/changeRouterType', command)
    }
  }
}
</script>

<style lang="scss" scoped>
.tags-view-container {
  height: 34px;
  overflow: hidden;
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #d8dce5;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .12), 0 0 3px 0 rgba(0, 0, 0, .04);
  .left-enter, .left-leave-to {
    transform: translate3d(-50%, 0, 0);
  }
  .left-leave, .left-enter-to {
    transform: translate3d(0, 0, 0);
  }
  .left-enter-active, .left-leave-active {
    transition: all .2s;
  }
  .contextmenu {
    margin: 0;
    background: #fff;
    z-index: 3000;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);
    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;
      &:hover {
        background: #eee;
      }
    }
  }
  .tags-view-left-menu{
    margin: 0 6px;
    color: #666;
    cursor: pointer;
    text-align: center;
  }
}
</style>

<style lang="scss">
//reset element css of el-icon-close
.tags-view-wrapper {
  .el-scrollbar__wrap{
    height: 47px;
  }
  .tags-view-item {
    .el-icon-close {
      width: 16px;
      height: 16px;
      vertical-align: 2px;
      border-radius: 50%;
      text-align: center;
      transition: all .3s cubic-bezier(.645, .045, .355, 1);
      transform-origin: 100% 50%;
      &:before {
        transform: scale(.6);
        display: inline-block;
        vertical-align: -3px;
      }
      &:hover {
        background-color: #b4bccc;
        color: #fff;
      }
    }
  }
}
.tags-view-left-menu-reference{
  font-size: 12px;
  position: relative;
  color: #409EFF;
  padding: 4px 10px;
  margin-top: 4px;
  transition: .5s
}
.tags-view-left-menu-reference:hover{
  -webkit-box-shadow:0 2px 12px 0 rgba(0,0,0,.2);
  -moz-box-shadow:0 2px 12px 0 rgba(0,0,0,.2);
  box-shadow:0 2px 12px 0 rgba(0,0,0,.2);
}
.tags-view-left-menu-popover{
  .tags-view-left-menu-title{
    float: left;
    padding-bottom:10px;
    margin-top:8px;
    padding-left:5px;
    padding-right:8px;
    font-size:12px;
    cursor:pointer;
  }
  .tags-view-left-menu-title:hover{
    color:#409EFF
  }
  .tags-view-left-menu-router{
    float: right;
    font-size: 12px;
    overflow: hidden;white-space: nowrap;text-overflow: ellipsis; max-width: 200px;
    .el-tag--mini{
      cursor:pointer;
    }
  }
  .tags-view-item {
    margin-bottom:10px;
    float: left;
  }

  .module-into{
    color: #409EFF;
    cursor:pointer;
    position: relative;
    top: 4px;
    .el-button{
      padding: 5px 10px;
    }
  }
}
.tags-view-item {
  display: inline-block;
  position: relative;
  cursor: pointer;
  height: 26px;
  line-height: 26px;
  border: 1px solid #d8dce5;
  color: #495060;
  background: #fff;
  padding: 0 8px;
  font-size: 12px;
  margin-left: 5px;
  margin-top: 4px;
  &:first-of-type {
    margin-left: 1px;
  }
  &:last-of-type {
    margin-right: 1px;
  }
  &.active {
    background-color: #42b983;
    color: #fff;
    border-color: #42b983;
    &::before {
      content: '';
      background: #fff;
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      position: relative;
      margin-right: 2px;
    }
  }
}
</style>
